import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      alignItems: 'flex-end',
      color: TextColors.dark,
    },
    header: {
      padding: muiTheme.spacing(0, 4),
      marginBottom: muiTheme.spacing(1),
    },
    row: {
      alignItems: 'baseline',
      display: 'flex',
      justifyContent: 'space-between',
    },
    filters: {
      alignItems: 'center',
      // background: ({ filtersBgColor }: any) => filtersBgColor,
      // color: ({ filtersTextColor }: any) => filtersTextColor,
      display: 'flex',
      flexDirection: 'row',
      padding: muiTheme.spacing(3, 0, 3, 2),

      '& .title': {
        flex: '0 0 90px',
        padding: muiTheme.spacing(0, 2),
        color: hexToRGBA(TextColors.dark, TextOpacities.dark2),
      },
    },
    tabs: {
      minHeight: '27px',
      '& .MuiTabs-indicator': {
        display: 'none',
      },
    },
    tab: {
      ...muiTheme.typography.body2,
      // color: ({ tabColor }: any) => tabColor,
      minHeight: '27px',
      minWidth: 0,
      padding: muiTheme.spacing(0, 2),
    },
    tabPlaceholder: {
      display: 'none',
    },
    sortBy: {
      display: 'inline-block',
      alignItems: 'center',
      // color: ({ sortByColor }: any) => sortByColor,
      marginBottom: muiTheme.spacing(0.5),
      marginRight: -6,
    },
    query: {
      '&.is-empty': {
        width: 0,
      },
    },
  }),
  { name: 'GenSearchResultsHeaderMobile' },
);

export default useStyles;
